import React, { useState } from 'react';
import axios from 'axios';

const GetAQuote = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    from: '',
    to: '',
    type: 'Residential',
    rooms: '',
    inventory: '',
    additionalInfo: '',
    newsletter: false
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('🚀 Submitting form with data:', formData);

    try {
      const response = await axios.post('https://api.jazuzmovingcompany.com/api/send-form', formData, {
        headers: {
          'Content-Type': 'application/json'
        }
      });

      console.log('✅ Success response from server:', response.data);
      alert('Quote submitted successfully!');
    } catch (error) {
      if (error.response) {
        console.error('❌ Server responded with error:', error.response.data);
      } else if (error.request) {
        console.error('❌ Request was made but no response:', error.request);
      } else {
        console.error('❌ Error setting up request:', error.message);
      }

      alert('Failed to send quote.');
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <input type="text" name="firstName" placeholder="First Name" value={formData.firstName} onChange={handleChange} />
      <input type="text" name="lastName" placeholder="Last Name" value={formData.lastName} onChange={handleChange} />
      <input type="email" name="email" placeholder="Email" value={formData.email} onChange={handleChange} />
      <input type="tel" name="phone" placeholder="Phone" value={formData.phone} onChange={handleChange} />
      <input type="text" name="from" placeholder="From Address" value={formData.from} onChange={handleChange} />
      <input type="text" name="to" placeholder="To Address" value={formData.to} onChange={handleChange} />

      <select name="type" value={formData.type} onChange={handleChange}>
        <option value="Residential">Residential</option>
        <option value="Commercial">Commercial</option>
      </select>

      <input type="number" name="rooms" placeholder="Number of Rooms" value={formData.rooms} onChange={handleChange} />
      <textarea name="inventory" placeholder="Inventory List" value={formData.inventory} onChange={handleChange} />
      <textarea name="additionalInfo" placeholder="Other Information" value={formData.additionalInfo} onChange={handleChange} />

      <label>
        <input type="checkbox" name="newsletter" checked={formData.newsletter} onChange={handleChange} />
        Subscribe to our newsletter
      </label>

      <button type="submit">Submit</button>
    </form>
  );
};

export default GetAQuote;
